import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AccountService } from '@cue-admin/account-data';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class AccountMenuComponent {
  private accountService = inject(AccountService);
  private router = inject(Router);

  onSetup() {
    this.router.navigateByUrl('/setup');
  }

  onLogout() {
    this.accountService.actionLogout().subscribe(() => {
      this.router.navigateByUrl('/account/login');
    });
  }
}
